export default class Timezone {
  userId!: number;
  timestamp!: number;
  timezone!: string;
  offset!: number;
  metadata?: any;
}
